import { ActionCardData, ActionCardModel, SectionData } from '@playbooks/action-cards-utils/src'

function getRequitedNotFilledFieldIds(sections: SectionData[], conditionalItems: number[]) {
  return (
    new ActionCardModel({ sections, conditionalItems } as ActionCardData)
      .getSearchService()
      .filterRequired()
      .filterVisible()
      .filterEmptyInputNodes()
      .map(field => (field.data as { id: string }).id) || []
  )
}

export default getRequitedNotFilledFieldIds
